// tslint:disable-next-line:interface-name
export interface IlessonTabMenu {
    homePageSelectedTab?: string;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    location?: any;
    dispatch?: any;
    moduleItems?: any;
}

export enum TabMenuItems {
    courseContent = 1,
    syllabus = 2,
    notepad = 3,
    announcements = 4,
    discussion = 5,
    files = 6,
    studentList = 7,
    processes = 8
}